import { render, staticRenderFns } from "./DiseaseImageComponent.vue?vue&type=template&id=a1a9cade&"
import script from "./DiseaseImageComponent.vue?vue&type=script&lang=js&"
export * from "./DiseaseImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports